<template>
	<Draggable class="sms-number-entry" :class="{'disabled':menuLoading}">
	<div  :class="{}" @click="$emit('click')">
		<v-spinner v-if="loading" />
		<div v-else class="headline" >
			<div>
				<span class="index" >
					<span class="x" >#{{index+1}}</span>
				</span>
			</div>
			<div class="flex layout-column ">
				<span class="name">{{code.name || 'Some nameless code!'}}</span>
				<span class="subtitle">
					{{localDate}}
				</span>
<!--				<span v-else class="subtitle">{{code.optin_email}}</span>-->
			</div>
			<div class="flex-none">
				<quick-actions-btn :items="['Edit', '', {label:'Delete code',icon:require('@/assets/img/trash.svg')}]"
				                   @menuClick="menuClick" :loading="menuLoading"/>
			</div>
		</div>
	</div>
	</Draggable>
</template>

<script>
import VButton from "@/components/base/v-button";
import API from '@/api';
import VSpinner from "@/components/base/v-spinner";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import MenuItem from "@/components/base/menu-item";
import { Container, Draggable } from 'vue-smooth-dnd'
import {mapGetters} from "vuex";

const moment = require('moment-timezone');

export default {
	name: "sms-number-entry",
	components: {MenuItem, QuickActionsBtn, VSpinner, VButton,Draggable},
	props:['code','loading','index'],
	mixins:[API],
	data(){
		return {
			menuLoading: false,
			open: false,
		}
	},
	computed:{
		...mapGetters(['getCodesStore']),
		localDate(){
			return moment(this.code.updated_at).format("DD MMMM YYYY, HH:mm:ss")
		},
	},
	methods:{
		menuClick(e){
			if (e.action==='Delete code') {
				this.deleteCode();
			} else {
				this.$emit('click')
			}
		},
		async deleteCode(){
			try {
				this.menuLoading = true;

				let code = await this.api.codes.delete(this.code.funnel_id, this.code.id);
				if (code.error) this.$error(code.error);
				else {
					let i = this.getCodesStore.findIndex(x=>x.id===this.code.id);
					if (i >= 0) {
						this.getCodesStore.splice(i, 1)
					}
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.menuLoading = false;
			}
		},

	},

}
</script>

<style lang="scss" scoped>
.sms-number-entry {
	position: relative;
	min-height: 30px;

	&.disabled {
		pointer-events: none;
		//background: $light-silver;
	}
	.headline {
		font-weight: 500;
		font-size: 16px;
		line-height: 150%;
		letter-spacing: 0.02em;
		color: #25242d;
		display: flex;
		flex-direction: row;
		position: relative;
		cursor: pointer;
		padding: 8px 15px;
		background: transparent;
		border-radius: 8px;
		opacity: 1;
		align-items: center;
		.name {
			font-weight: 600;
			font-size: 14px;
			color: $black;
		}
		.subtitle {
			font-weight: 400;
			font-size: 14px;
			color: $dark-grey;
		}
		&:hover {
			background: #f7f7f7;
		}
		&.open {
			background: #f7f7f7;
		}
		.index {
			color: $grey;
			font-size: 18px;
			height: 40px;
			width: 40px;
			position: relative;
			display: flex;
			margin-right: 10px;
			//background: silver;
			cursor: grab;
			.x {
				margin: 0;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
}
</style>
